import React from "react";
import { Radar } from "react-chartjs-2";
const WeatherRadarChart = ({ weatherStats = {}, avgTemp = 0 }) => {
  const labels = ["صحو", "ممطر", "غائم", "رياح", "متوسط الحرارة"];

  const weatherData = [
    weatherStats?.clear || 0,
    weatherStats?.rainy || 0,
    weatherStats?.cloudy || 0,
    weatherStats?.winds || 0,
    avgTemp || 0,
  ];

  const data = {
    labels: labels,
    datasets: [
      {
        label: "إحصائيات الطقس",
        data: weatherData,
        borderColor: "#2980b9",
        backgroundColor: "rgba(41, 128, 185, 0.4)",
        borderWidth: 2,
      },
    ],
  };

  const options = {

    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      streaming: false,
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}`;
          },
        },
      },
    },
    scales: {
      r: {
        angleLines: { display: true },
        suggestedMin: 0,
        ticks: {
          beginAtZero: true,
          font: { family: "Cairo" },
        },
        pointLabels: {
          font: {
            family: "Cairo",
            size: 13,
          },
        },
      },
    },
  };

  return (
    <div
      className="card p-3"
      style={{
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        background: "#ecf0f1",
        color: "#2c3e50",
      }}
    >
      <h5
        className="text-center mb-3"
        style={{ fontFamily: "Cairo", fontWeight: "600" }}
      >
        تحليل الطقس ودرجة الحرارة
      </h5>
      <div style={{ height: 300 }}>
        <Radar data={data} options={options} />
      </div>
    </div>
  );
};

export default WeatherRadarChart;
